<template>
  <div>
    <v-dialog
      v-model="template_selection_dialog"
      width="500"
      persistent
      scrollable
    >
      <v-card
        style="position: relative; padding-bottom: 20px"
        min-height="550"
        width="500"
      >
        <v-toolbar flat>
          <v-toolbar-title style="font-weight: bold"
            >Select Machine Template</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="grey"
            dark
            @click="cancel_template_selection_dialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 py-2">
          <v-text-field
            outlined
            single-line
            dense
            hide-details
            placeholder="Serach machine template"
            v-model="search_machine_template"
            @input="search_machine_template_updated"
          ></v-text-field>
        </div>
        <div
          class="overflow-y-auto overflow-x-hidden"
          style="text-align: left; max-height: 550px; min-height: 550px"
        >
          <MachineTemplateDialogSelection
            :machine_template_list="temp_template_list"
            @machine_template_selected="machine_template_selected"
          ></MachineTemplateDialogSelection>
        </div>
      </v-card>
    </v-dialog>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>Machine Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="machine_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          :show-select="true"
          v-model="selected_machines"
          @click:row="view_machine"
          item-key="machine_doc_id"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Machines"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                color="blue"
                dark
                style="text-transform: capitalize"
                :class="current_user_company_doc_id == '' ? 'mr-5' : ''"
                @click="template_selection_dialog = true"
                v-if="false"
              >
                <v-icon left dark> mdi-update </v-icon>
                Mass Update VM Product
              </v-btn>
              <v-btn
                depressed
                color="primary"
                dark
                style="text-transform: capitalize"
                @click="create_machine"
                v-if="current_user_company_doc_id == ''"
              >
                <v-icon left dark> mdi-plus </v-icon>
                Create Machine
              </v-btn>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
  </div>
</template>

<script>
import MachineTemplateDialogSelection from "../components/MachineTemplateDialogSelection.vue";

export default {
  components: {
    MachineTemplateDialogSelection,
  },
  data: function () {
    return {
      template_selection_dialog: false,
      search_machine_template: "",
      headers: [
        {
          text: "Machine ID",
          value: "machine_id",
          sortable: true,
          divider: true,
        },
        {
          text: "Machine Name",
          value: "machine_name",
          sortable: true,
          divider: true,
        },
        {
          text: "Machine Type",
          value: "machine_type",
          sortable: true,
          divider: true,
        },
        {
          text: "Owner",
          value: "owner_username",
          sortable: true,
          divider: true,
        },
        {
          text: "Location Name",
          value: "location_name",
          sortable: true,
          divider: true,
        },
        {
          text: "Version",
          value: "version_number",
          sortable: true,
          divider: false,
        },
      ],
      machine_list: [],
      table_loading: false,
      search: "",
      current_user_permission: [],
      current_user_company_doc_id: "",
      selected_machines: [],

      machine_template_list: [],
      temp_template_list: [],
    };
  },
  methods: {
    async machine_template_selected(selected_machine_template) {
      var selected_template_id = selected_machine_template.template_id;
      var nubox2machine_id = [];
      this.selected_machines.forEach((selected_machine) => {
        if (selected_machine.machine_type == "nubox_v2") {
          nubox2machine_id.push(selected_machine.machine_doc_id);
        }
      });
      this.cancel_template_selection_dialog();
      this.show_close_loading("show", "Updating");
      const response = (
        await this.send_http_request("massUpdateMachine", {
          template_id: selected_template_id,
          machine_list: nubox2machine_id,
        })
      ).data;
      this.show_close_loading("close");
      if (response.status == "OK") {
        this.show_snack_bar("success", "Machines updated");
      } else {
        this.show_snack_bar("error", "Something went wrong");
      }
    },
    search_machine_template_updated() {
      this.temp_template_list = this.filterByValue(
        this.machine_template_list,
        this.search_machine_template
      );
    },
    filterByValue(array, value) {
      return array.filter((data) =>
        data.machine_template_name.toLowerCase().includes(value.toLowerCase())
      );
    },
    cancel_template_selection_dialog() {
      this.template_selection_dialog = false;
      this.search_machine_template = "";
      this.temp_template_list = this.machine_template_list;
    },
    load_machine_template() {
      this.table_loading = true;
      this.send_http_request("getAllMachineTemplateWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          if (response.data.status == "OK") {
            response.data.result.forEach((template) => {
              if (template.machine_type == "Nubox_v2") {
                this.machine_template_list.push(template);
                this.temp_template_list.push(template);
              }
            });
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    view_machine(machine) {
      this.$router
        .push({
          name: "MachineDetailScreen",
          params: { id: machine.machine_doc_id },
        })
        .catch((err) => {});
    },
    load_machine() {
      this.table_loading = true;
      this.send_http_request("getAllMachinesWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.machine_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    create_machine() {
      this.$router
        .push({ name: "MachineDetailScreen", params: { id: "create" } })
        .catch((err) => {});
    },
  },
  mounted() {
    this.load_machine();
    this.load_machine_template();
  },
  created() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      if (
        !this.current_user_permission.includes("3BAFVFaySyJIFMdot8rB") &&
        !this.current_user_permission.includes("xg3QiWhT2SA6KdkGFAeP") &&
        !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      }
    }
    // Update store
    var payload = { headerType: "needHeader", currentPage: "MachineScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>